/**
 * 返回「本地日历日期」的固定格式字符串 YYYY-MM-DD，与浏览器语言环境无关。
 * 用于按天比较、存储、频率控制等，保证同一自然日在任意地区得到相同字符串。
 * 多时区场景下：每个用户看到的是自己当地的「今天」，格式统一为 YYYY-MM-DD。
 *
 * @param date 可选，默认当前时间。会按该日期的本地年/月/日格式化。
 * @returns 例如 "2025-03-10"
 */
export function getLocalDateString(date: Date = new Date()): string {
  const y = date.getFullYear();
  const m = date.getMonth() + 1;
  const d = date.getDate();
  return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
}

const YYYY_MM_DD_REG = /^\d{4}-\d{2}-\d{2}$/;

/**
 * 将存量/历史日期值规范化为本地 YYYY-MM-DD，用于兼容旧版 localStorage 数据。
 * 支持的输入：已为 YYYY-MM-DD 的字符串、ISO 日期时间字符串、时间戳（数字或数字字符串）。
 * 无法识别或无效时返回 null，调用方应视作「无效或过期」并改用 getLocalDateString()。
 *
 * @param value 可能来自旧版的 date / loadList0 等
 * @returns 规范后的 "YYYY-MM-DD" 或 null
 */
export function normalizeToLocalDateString(value: unknown): string | null {
  if (value == null) return null;
  const s = String(value).trim();
  if (!s) return null;
  // 已是标准 YYYY-MM-DD，直接视为本地日期返回
  if (YYYY_MM_DD_REG.test(s)) return s;
  const ts = typeof value === 'number' ? value : Date.parse(s);
  if (Number.isNaN(ts)) return null;
  return getLocalDateString(new Date(ts));
}
